import { render, staticRenderFns } from "./Paginas.vue?vue&type=template&id=d28d0e72&scoped=true"
import script from "./Paginas.vue?vue&type=script&lang=js"
export * from "./Paginas.vue?vue&type=script&lang=js"
import style0 from "./Paginas.vue?vue&type=style&index=0&id=d28d0e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28d0e72",
  null
  
)

export default component.exports